module.exports = __webpack_public_path__ + "media/music/8ca9997e9ed7534a8d0f349a6125bd24.mp3";